import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// استيراد الصور من مجلد assets
import leftArrowIcon from '../assets/left.png';
import uploadIcon from '../assets/upload.png';
import backImage from '../assets/back.jpg'; // لـ simulatedOriginalMask و simulatedPredictedImage

const DiagnosisModel = () => {
  // State for Classification Model
  const [classificationFile, setClassificationFile] = useState(null);
  const [classificationFileName, setClassificationFileName] = useState('No file chosen');
  const [classificationPreviewUrl, setClassificationPreviewUrl] = useState('');
  const [classificationMessage, setClassificationMessage] = useState('');
  const [classificationError, setClassificationError] = useState('');
  const classificationFileInputRef = useRef(null);

  // State for Segmentation Model
  const [segmentationFile, setSegmentationFile] = useState(null);
  const [segmentationFileName, setSegmentationFileName] = useState('No file chosen');
  const [segmentationPreviewUrl, setSegmentationPreviewUrl] = useState('');
  const [segmentationMessage, setSegmentationMessage] = useState('');
  const [segmentationError, setSegmentationError] = useState('');
  const segmentationFileInputRef = useRef(null);

  const navigate = useNavigate();

  // Handle file change for Classification
  const handleClassificationFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const acceptedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      if (!acceptedTypes.includes(file.type)) {
        setClassificationError('Unsupported file type. Please choose a PNG, JPG, or JPEG image.');
        setClassificationFile(null);
        setClassificationFileName('No file chosen');
        setClassificationPreviewUrl('');
        return;
      }
      setClassificationFile(file);
      setClassificationFileName(file.name);
      setClassificationPreviewUrl(URL.createObjectURL(file));
      setClassificationError('');
      setClassificationMessage('');
    } else {
      setClassificationFile(null);
      setClassificationFileName('No file chosen');
      setClassificationPreviewUrl('');
    }
  };

  // Handle file change for Segmentation
  const handleSegmentationFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const acceptedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      if (!acceptedTypes.includes(file.type)) {
        setSegmentationError('Unsupported file type. Please choose a PNG, JPG, or JPEG image.');
        setSegmentationFile(null);
        setSegmentationFileName('No file chosen');
        setSegmentationPreviewUrl('');
        return;
      }
      setSegmentationFile(file);
      setSegmentationFileName(file.name);
      setSegmentationPreviewUrl(URL.createObjectURL(file));
      setSegmentationError('');
      setSegmentationMessage('');
    } else {
      setSegmentationFile(null);
      setSegmentationFileName('No file chosen');
      setSegmentationPreviewUrl('');
    }
  };

  // Handle Classify button click
  const handleClassify = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (!classificationFile) {
      setClassificationError('Please choose a file to classify.');
      return;
    }

    setClassificationMessage('Classifying image...');
    setClassificationError('');

    const formData = new FormData();
    formData.append('image', classificationFile);

    try {
      // Simulate API call for classification
      // const response = await fetch('/api/classify', {
      //   method: 'POST',
      //   body: formData,
      // });
      // const data = await response.json();

      // if (response.ok) {
        setClassificationMessage('Image classified successfully! Redirecting to results...');
        // Simulate a result and navigate
        const simulatedClassificationResult = "Normal-cecum"; // Example result
        setTimeout(() => {
          navigate('/classification-model', { state: { result: simulatedClassificationResult, imageUrl: classificationPreviewUrl } });
        }, 1500);
      // } else {
      //   setClassificationError(data.message || 'Failed to classify image. Please try again.');
      //   setClassificationMessage('');
      // }
    } catch (err) {
      setClassificationError('An error occurred during classification. Please try again later.');
      setClassificationMessage('');
    }
  };

  // Handle Segment button click
  const handleSegment = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (!segmentationFile) {
      setSegmentationError('Please choose a file to segment.');
      return;
    }

    setSegmentationMessage('Segmenting image...');
    setSegmentationError('');

    const formData = new FormData();
    formData.append('image', segmentationFile);

    try {
      // Simulate API call for segmentation
      // const response = await fetch('/api/segment', {
      //   method: 'POST',
      //   body: formData,
      // });
      // const data = await response.json();

      // if (response.ok) {
        setSegmentationMessage('Image segmented successfully! Redirecting to results...');
        // Simulate results and navigate
        const simulatedOriginalMask = backImage; // استخدام المتغير المستورد
        const simulatedPredictedImage = backImage; // استخدام المتغير المستورد
        setTimeout(() => {
          navigate('/segmentation-model', { state: { originalImage: segmentationPreviewUrl, originalMask: simulatedOriginalMask, predictedImage: simulatedPredictedImage } });
        }, 1500);
      // } else {
      //   setSegmentationError(data.message || 'Failed to segment image. Please try again.');
      //   setSegmentationMessage('');
      // }
    } catch (err) {
      setSegmentationError('An error occurred during segmentation. Please try again later.');
      setSegmentationMessage('');
    }
  };


  return (
    <div className="flex flex-col min-h-screen bg-[var(--bg)] relative overflow-hidden" style={{ fontFamily: 'var(--font-body)' }}>
      {/* زر العودة للصفحة الرئيسية */}
      <Link to="/home" className="absolute top-4 left-4 z-20">
        <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white border border-[var(--mist)] shadow-sm">
          <img src={leftArrowIcon} alt="Back" className="w-5 h-5" />
        </span>
      </Link>

      {/* الحاوية الرئيسية لأقسام التصنيف والتقسيم - تأخذ عرض وطول الشاشة بالكامل */}
      <div className="flex-grow flex flex-col md:flex-row w-full h-full p-4 md:p-8 pt-16 md:pt-20 gap-4 md:gap-8 justify-center items-stretch">
        {/* قسم نموذج التصنيف */}
        <div className="flex-1 bg-white rounded-2xl border border-[var(--mist)] shadow-sm p-6 text-center flex flex-col justify-between">
          <div>
            <p className="text-2xl font-medium text-[var(--ink)] mb-6" style={{ fontFamily: 'var(--font-display)' }}>
              Classification Model
            </p>
            <h5 className="text-lg font-semibold text-[var(--teal)] mb-4">Choose An Image File For Classification</h5>

            <form onSubmit={handleClassify}>
              <div className="flex flex-col items-center justify-center border-2 border-dashed border-[var(--teal)]/40 rounded-xl p-6 mb-4 bg-[var(--teal)]/5">
                <img src={uploadIcon} alt="Upload" className="w-12 h-12 mb-2" />
                <p className="text-[var(--ink)] font-semibold text-lg mb-1">Drag and drop file here</p>
                <p className="text-[var(--ink)]/60 text-sm">Limit 200MB Per file. JPG, PNG, JPEG</p>
                <input
                  type="file"
                  id="classification-file"
                  name="browse"
                  hidden
                  accept=".png,.jpg,.jpeg"
                  onChange={handleClassificationFileChange}
                  ref={classificationFileInputRef}
                />
                <label htmlFor="classification-file" className="mt-4 bg-[var(--teal)] hover:bg-[var(--teal-deep)] text-white font-semibold py-2 px-4 rounded-lg cursor-pointer transition duration-300">
                  Browse Files
                </label>
                <p className="mt-2 text-[var(--ink)]/70 text-sm">{classificationFileName}</p>
              </div>

              {classificationPreviewUrl && (
                <div className="mt-4">
                  <img src={classificationPreviewUrl} alt="Classification preview" className="w-48 h-auto object-contain mx-auto rounded-lg border border-[var(--mist)] shadow-sm" />
                </div>
              )}

              {classificationMessage && <p className="text-[var(--teal-deep)] text-sm mt-4">{classificationMessage}</p>}
              {classificationError && <p className="text-[var(--coral)] text-sm mt-4">{classificationError}</p>}
            </form>
          </div>
          <button type="submit" onClick={handleClassify} className="mt-6 bg-[var(--teal)] hover:bg-[var(--teal-deep)] text-white font-bold py-3 px-8 rounded-full shadow-sm transition duration-300 text-xl w-full">
            Classify
          </button>
        </div>

        {/* قسم نموذج التقسيم */}
        <div className="flex-1 bg-white rounded-2xl border border-[var(--mist)] shadow-sm p-6 text-center flex flex-col justify-between">
          <div>
            <p className="text-2xl font-medium text-[var(--ink)] mb-6" style={{ fontFamily: 'var(--font-display)' }}>
              Segmentation Model
            </p>
            <h5 className="text-lg font-semibold text-[var(--teal)] mb-4">Choose An Image File For Segmentation</h5>

            <form onSubmit={handleSegment}>
              <div className="flex flex-col items-center justify-center border-2 border-dashed border-[var(--teal)]/40 rounded-xl p-6 mb-4 bg-[var(--teal)]/5">
                <img src={uploadIcon} alt="Upload" className="w-12 h-12 mb-2" />
                <p className="text-[var(--ink)] font-semibold text-lg mb-1">Drag and drop file here</p>
                <p className="text-[var(--ink)]/60 text-sm">Limit 200MB Per file. JPG, PNG, JPEG</p>
                <input
                  type="file"
                  id="segmentation-file"
                  name="browse"
                  hidden
                  accept=".png,.jpg,.jpeg"
                  onChange={handleSegmentationFileChange}
                  ref={segmentationFileInputRef}
                />
                <label htmlFor="segmentation-file" className="mt-4 bg-[var(--teal)] hover:bg-[var(--teal-deep)] text-white font-semibold py-2 px-4 rounded-lg cursor-pointer transition duration-300">
                  Browse Files
                </label>
                <p className="mt-2 text-[var(--ink)]/70 text-sm">{segmentationFileName}</p>
              </div>

              {segmentationPreviewUrl && (
                <div className="mt-4">
                  <img src={segmentationPreviewUrl} alt="Segmentation preview" className="w-48 h-auto object-contain mx-auto rounded-lg border border-[var(--mist)] shadow-sm" />
                </div>
              )}

              {segmentationMessage && <p className="text-[var(--teal-deep)] text-sm mt-4">{segmentationMessage}</p>}
              {segmentationError && <p className="text-[var(--coral)] text-sm mt-4">{segmentationError}</p>}
            </form>
          </div>
          <button type="submit" onClick={handleSegment} className="mt-6 bg-[var(--teal)] hover:bg-[var(--teal-deep)] text-white font-bold py-3 px-8 rounded-full shadow-sm transition duration-300 text-xl w-full">
            Segment
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiagnosisModel;
